import {
  Box,
  Button,
  Container,
  Field,
  Flex,
  Input,
  Stack,
  InputGroup,
  Center,
  Text,
} from '@chakra-ui/react'
import ToggleColorMode from '@components/ToggleColorMode'
import { LuLock, LuMail } from 'react-icons/lu'
import { Link as RouterLink } from 'react-router';
import Logo from '@components/Logo'
import AuthImagePlaceholder from '@components/AuthImagePlaceholder'
import ErrorLabel from '@components/ErrorLabel'
import PasswordInput from '@components/PasswordInput'

import useForm from './useForm'

const Login = () => {
  const { onSubmit, loading, errors } = useForm();

  return (
    <Flex height="100vh" flex="1">
      <Box position="absolute" top="4" left="4">
        <ToggleColorMode />
      </Box>
      <Center flex="1.5" py={{ base: '24', md: '32' }}>
        <Container maxW="md">
          <Stack gap="8">
            <Flex justifyContent="center">
              <Logo />
            </Flex>
            <form onSubmit={onSubmit}>
              <Stack gap="5">
                <Field.Root invalid={!!errors?.email}>
                  <Field.Label>E-mail</Field.Label>
                  <InputGroup startElement={<LuMail />} width="full" gap={0}>
                    <Input name="email" type="email" placeholder="exemplo@email.com" variant="subtle" required />
                  </InputGroup>
                  {errors?.email?.map((error, index) => (
                    <Field.ErrorText key={index}>{error}</Field.ErrorText>
                  ))}
                </Field.Root>
                <Field.Root invalid={!!errors?.password}>
                  <Field.Label>Senha</Field.Label>
                  <InputGroup startElement={<LuLock />} width="full" gap={0}>
                    <PasswordInput name="password" placeholder="••••••••" variant="subtle" required />
                  </InputGroup>
                  {errors?.password?.map((error, index) => (
                    <Field.ErrorText key={index}>{error}</Field.ErrorText>
                  ))}
                </Field.Root>
                {errors?.general && (
                  <Flex direction="column" my={4}>
                    {errors.general.map((error, index) => (
                      <ErrorLabel key={index} text={error} />
                    ))}
                  </Flex>
                )}
                <Button
                  colorPalette="argos"
                  type="submit"
                  loading={loading}
                >
                  Entrar
                </Button>
                <RouterLink to="/esqueci-senha">
                  <Text textDecoration="underline" color="argos.fg">
                    Esqueci a senha
                  </Text>
                </RouterLink>
              </Stack>
            </form>
          </Stack>
        </Container>
      </Center>
      <Box flex="1" hideBelow="lg">
        <AuthImagePlaceholder />
      </Box>
    </Flex>
  );
};

export default Login;
